import React, { useEffect, useState } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { api } from "../lib/api";

export default function EmailDeliveryPanel() {
  const [data, setData] = useState({ items: [], pending: 0, failed: 0 });
  const load = () => api.get("/admin/email-outbox").then(r => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const retry = async (id) => { await api.post(`/admin/email-outbox/${id}/retry`); load(); };

  return (
    <div className="border border-[#2B2B2B] bg-[#111111] p-5 mb-8" data-testid="email-delivery-panel">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-bebas text-2xl uppercase">Email Delivery</h3>
        <button onClick={load} className="btn-ghost text-xs" data-testid="email-delivery-refresh"><RefreshCw size={14}/> Refresh</button>
      </div>
      {data.items.length === 0 ? (
        <p className="text-sm text-[#A1A1AA]" data-testid="email-delivery-ok">All notification emails delivered. Nothing waiting or failed.</p>
      ) : (
        <>
          <div className="flex items-center gap-2 text-sm text-[#FF6A00] mb-3" data-testid="email-delivery-alert">
            <AlertTriangle size={16}/> {data.failed} failed · {data.pending} waiting to retry (automatic every minute)
          </div>
          <div className="space-y-2">
            {data.items.map(i => (
              <div key={i.outbox_id} className="border border-[#2B2B2B] bg-[#0A0A0A] p-3 text-xs flex flex-wrap justify-between gap-2" data-testid={`outbox-${i.outbox_id}`}>
                <div>
                  <div className="text-[#E6E6E6]">{i.subject}</div>
                  <div className="text-[#A1A1AA]">To {i.to} · {i.status} · {i.attempts} attempts · {i.last_error}</div>
                </div>
                {i.status === "failed" && (
                  <button onClick={() => retry(i.outbox_id)} className="btn-primary text-xs" data-testid={`outbox-retry-${i.outbox_id}`}>Retry</button>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
